var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Email Icon - Green"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25865",
    fill: "none",
    d: "M0 0h74v74H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Email Icon - Green"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 222",
    d: "M72.278 20.133a7.028 7.028 0 00-7.028-7.028H9.028A7.028 7.028 0 002 20.133v33.733a7.028 7.028 0 007.028 7.028H65.25a7.028 7.028 0 007.028-7.028zm-63.25-4.217H65.25a4.217 4.217 0 014.155 3.514L39.478 39.373a4.2 4.2 0 01-4.677 0L4.873 19.43a4.217 4.217 0 014.155-3.514zM65.25 58.083H9.028a4.217 4.217 0 01-4.217-4.217v-31.1L33.24 41.712a7.01 7.01 0 007.8 0l28.429-18.943v31.1a4.217 4.217 0 01-4.219 4.214z",
    fill: "currentColor"
  })))));
}

export default __webpack_public_path__ + "044482b52c8195fd4405db06888a759c.svg";
export { SvgEmailIcon as ReactComponent };